const RESET_VALUE = /* @__PURE__ */ Symbol.for("com.tldraw.state/RESET_VALUE");
export {
  RESET_VALUE
};
//# sourceMappingURL=types.mjs.map
